import React from 'react';
import { NavigationMenuButton } from '@ditioas/web-ui';
import { useSetAtom } from 'jotai';
import { Link, useLocation } from 'react-router';
import useMedia from 'use-media';

import config from 'config/site.config';
import type { MenuContent } from 'model/Menu/types';

import { navMenuStateAtom } from '../Layout';
import getLinkIcon from './getLinkIcon';

const styles = getComputedStyle(document.documentElement);
const sidebarBreakpoint = styles.getPropertyValue(
  '--breakpoint-sidebarBreakpoint'
);

const { legacyWebBaseUrl } = config;

interface PageLinkProps {
  page: MenuContent[number]['pages'][number];
}

const PageLink = ({ page: { name, link, title, isLegacy } }: PageLinkProps) => {
  const { pathname } = useLocation();
  const setMenuOpen = useSetAtom(navMenuStateAtom);
  const isWide = useMedia(
    {
      minWidth: parseInt(sidebarBreakpoint, 10),
    },
    true
  );

  const active = React.useMemo(
    () => pathname.startsWith(`/${link}`),
    [link, pathname]
  );

  const icon = getLinkIcon(name);

  if (link.toLowerCase().startsWith('https')) {
    return (
      <NavigationMenuButton active={false}>
        <a href={link}>
          {icon}
          {title}
        </a>
      </NavigationMenuButton>
    );
  }

  if (isLegacy) {
    return (
      <NavigationMenuButton active={false}>
        <a href={`${legacyWebBaseUrl}/${link}`}>
          {icon}
          {title}
        </a>
      </NavigationMenuButton>
    );
  }

  return (
    <NavigationMenuButton
      key={link}
      onClick={() => {
        if (!isWide) {
          setMenuOpen(false);
        }
      }}
      active={active}
    >
      <Link to={`../${link}`}>
        {icon}
        {title}
      </Link>
    </NavigationMenuButton>
  );
};

export default PageLink;
